/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplyWorkOrderMergeRequestDto
 */
export interface ApplyWorkOrderMergeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ApplyWorkOrderMergeRequestDto
     */
    targetWorkOrderId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplyWorkOrderMergeRequestDto
     */
    sourceWorkOrderIds: Array<string>;
}

/**
 * Check if a given object implements the ApplyWorkOrderMergeRequestDto interface.
 */
export function instanceOfApplyWorkOrderMergeRequestDto(value: object): value is ApplyWorkOrderMergeRequestDto {
    if (!('targetWorkOrderId' in value) || value['targetWorkOrderId'] === undefined) return false;
    if (!('sourceWorkOrderIds' in value) || value['sourceWorkOrderIds'] === undefined) return false;
    return true;
}

export function ApplyWorkOrderMergeRequestDtoFromJSON(json: any): ApplyWorkOrderMergeRequestDto {
    return ApplyWorkOrderMergeRequestDtoFromJSONTyped(json, false);
}

export function ApplyWorkOrderMergeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplyWorkOrderMergeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'targetWorkOrderId': json['targetWorkOrderId'],
        'sourceWorkOrderIds': json['sourceWorkOrderIds'],
    };
}

export function ApplyWorkOrderMergeRequestDtoToJSON(json: any): ApplyWorkOrderMergeRequestDto {
    return ApplyWorkOrderMergeRequestDtoToJSONTyped(json, false);
}

export function ApplyWorkOrderMergeRequestDtoToJSONTyped(value?: ApplyWorkOrderMergeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetWorkOrderId': value['targetWorkOrderId'],
        'sourceWorkOrderIds': value['sourceWorkOrderIds'],
    };
}

